import type { ChubbQuoteSuccess } from '@/services/chubbApi'
import type { CoberturaDetalle, CotizaTodasResponse } from '@/types/quote.types'

/** Chubb Id_Cia in portal convention. */
export const CHUBB_ID_CIA = 5

type ChubbCoverageLine = ChubbQuoteSuccess['coberturas'][number]

function mapCoverage(c: ChubbCoverageLine, index: number): CoberturaDetalle {
  return {
    Id_Cobertura: index + 1,
    PrimaNeta: c.primaNeta ?? 0,
    PrimaTotal: c.primaNeta ?? 0,
    Nombre: c.nombre || 'Cobertura',
    EstaAmparada: true,
    Show: true,
    SumaAsegurada: c.sumaAsegurada === null ? 'AMPARADA' : String(c.sumaAsegurada),
    Deducible: c.deducible === null ? '' : String(c.deducible),
    Coaseguro: '',
    Observaciones: '',
  }
}

function amount(value: number | null | undefined): number {
  return value ?? 0
}

function mapTotals(cob: ChubbQuoteSuccess['cobertura']) {
  return {
    PrimaNeta: amount(cob?.primaNeta),
    DerechosPoliza: amount(cob?.derechosPoliza),
    IVA: amount(cob?.iva),
    Recargos: amount(cob?.recargos),
    PrimaTotal: amount(cob?.primaTotal),
    PrimaTotalPrimerRecibo: amount(cob?.primaTotalPrimerRecibo ?? cob?.primaTotal),
  }
}

function mapCobertura(
  quote: ChubbQuoteSuccess,
  portalQuoteId: number,
): NonNullable<CotizaTodasResponse['Cobertura']> {
  const session = quote.providerSession
  return {
    Cotizacion: null,
    Error: null,
    Id_Cotizacion_Propuesta: String(session.quoteId),
    Detalle: null,
    Id_Productos_Paquete: session.packageId,
    ...mapTotals(quote.cobertura),
    Comision: 0,
    PrimaTotalSubsecuentes: 0,
    UsuarioAdd: 0,
    Id_Cia: CHUBB_ID_CIA,
    Id_Cotizacion: portalQuoteId,
    Id_Cobertura: 0,
    Request: '',
    Response: JSON.stringify(session),
    Coberturas: quote.coberturas.map(mapCoverage),
    Asistencias: [],
    ValorVehiculo: 0,
    Nombre: 'Chubb',
    FormaPago: 'C',
    Pagos: 1,
  }
}

export function mapChubbQuoteToCotizaResponse(
  quote: ChubbQuoteSuccess,
  portalQuoteId = 0,
): CotizaTodasResponse {
  return {
    success: true,
    dataType: null,
    errorMessage: null,
    successMessage: null,
    data: null,
    dataModel: null,
    total: 0,
    dataTable: null,
    Json: { chubb: quote.providerSession },
    Cobertura: mapCobertura(quote, portalQuoteId),
  }
}
